import { environment as devDeployEnvironment } from '../../environments/deploy/environment.dev';
import { environment as prodDeployEnvironment } from '../../environments/deploy/environment.prod';
import { environment as qaDeployEnvironment } from '../../environments/deploy/environment.qa';

/**
 * Returns the LaunchDarkly client ID for the given grid region.
 */
export function getLaunchDarklyClientIdForGrid(grid: string): string {
  const normalisedGrid = grid.toLowerCase();
  const isDevGrid = ['dev', 'devrh'].includes(normalisedGrid);
  const isQAGrid = ['qa', 'snd', 'stg', 'lt', 'stgrh'].includes(normalisedGrid);

  if (isDevGrid) {
    return devDeployEnvironment.launchDarklyClientId;
  } else if (isQAGrid) {
    return qaDeployEnvironment.launchDarklyClientId;
  } else {
    return prodDeployEnvironment.launchDarklyClientId;
  }
}
